import React from 'react';
import classNames from 'classnames';
import CmsComponentGrid from '../../components/CmsComponentGrid';
import { CONTAINER_NAME } from '../../constants/analyticsNames';
import { usePromoClickEvent } from '../../hooks/use-promo-click-event';
import styles from '../../components/Container/index.module.scss';
import AnchorLink from '../../components/AnchorLink';
import { CONTAINER } from '../../constants/cmsResourceTypes';
const ContainerComponents = ({ childComponents, constrainContent = false, cqResponsive, preloadImages = false, }) => {
    if (constrainContent) {
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement(CmsComponentGrid, { childComponents: childComponents, cqResponsive: cqResponsive, preloadImages: preloadImages })));
    }
    return (React.createElement(CmsComponentGrid, { childComponents: childComponents, cqResponsive: cqResponsive, preloadImages: preloadImages }));
};
const Container = ({ analytics, analyticsTags, backgroundColor, childComponents, constrainContent = false, cqResponsive, cqResponsiveClasses, elementId, fullWidth = false, linkPath, newWindow = false, position, uniqueId, preloadImages, }) => {
    const promoClickEvent = usePromoClickEvent();
    const props = {
        'data-testid': 'container',
        className: classNames(cqResponsiveClasses, {
            [styles.fullWidth]: fullWidth,
        }),
        id: elementId || uniqueId,
        'data-uniqueid': uniqueId,
        style: { backgroundColor },
    };
    const containerContent = (React.createElement(ContainerComponents, { childComponents: childComponents, constrainContent: fullWidth && constrainContent, cqResponsive: cqResponsive, preloadImages: preloadImages }));
    if (linkPath) {
        const promoClickProps = Object.assign(Object.assign({}, analytics), { creative: CONTAINER_NAME, id: uniqueId, linkUrl: linkPath, name: analytics === null || analytics === void 0 ? void 0 : analytics.promoName, newWindow,
            position });
        const linkProps = Object.assign(Object.assign({ onClick: () => promoClickEvent(promoClickProps) }, props), analyticsTags);
        return (React.createElement(AnchorLink, Object.assign({ href: linkPath, newWindow: newWindow }, linkProps), containerContent));
    }
    return React.createElement("section", Object.assign({}, props), containerContent);
};
Container.displayName = CONTAINER_NAME;
Container.resourceType = CONTAINER;
export default Container;
//# sourceMappingURL=index.js.map